module.exports = __webpack_public_path__ + "static/media/field-selected.f54b89bc.svg";